import { graphql, useStaticQuery } from 'gatsby';

export const useGetLnWebsite = (langcode: Languages, countryCode: string) => {
  const data = useStaticQuery<{
    allLnWebsiteLnWebsite: { edges: { node: ILnWebsiteLnWebsite }[] };
  }>(graphql`
    query {
      allLnWebsiteLnWebsite {
        edges {
          node {
            langcode
            third_party_settings {
              ln_seo_ipredirect {
                bt_leave
                bt_stay
                text
              }
            }
            country
            base_url
            id
          }
        }
      }
    }
  `);

  const filteredByLanguage =
    data.allLnWebsiteLnWebsite.edges.filter(
      (item: { node: ILnWebsiteLnWebsite }) => item.node.langcode === langcode,
    ) || null;

  const lnWebsiteCountry = filteredByLanguage?.find(
    (item: { node: ILnWebsiteLnWebsite }) => item.node.country === countryCode,
  )?.node;

  const lnBaseWebsiteIpredirect = filteredByLanguage?.find(
    (item: { node: ILnWebsiteLnWebsite }) => item.node.country === 'US',
  )?.node.third_party_settings.ln_seo_ipredirect;

  const lnWebsite = {
    countryCode: lnWebsiteCountry?.country ?? '',
    siteUrl: lnWebsiteCountry?.base_url ?? '',
    ipredirectSettings: lnBaseWebsiteIpredirect,
    id: lnWebsiteCountry?.id ?? '',
  };

  return lnWebsite;
};
